import { useState } from 'react'
import { api, ErroreApi } from '../servizi/api.ts'
import { useSessione } from '../servizi/sessione.tsx'
import { Bottone } from './base.tsx'

/**
 * Impersonazione in sola lettura (524): la fascia sotto la testata, su ogni pagina, finche' dura.
 *
 * Come per la palestra, tornando al proprio profilo la pagina si ricarica da capo: sedi, cataloghi e
 * permessi letti dopo l'accesso sono quelli dell'utente impersonato.
 */
export function FasciaImpersonazione() {
  const { io } = useSessione()
  const [inCorso, setInCorso] = useState(false)
  const [errore, setErrore] = useState<string | null>(null)
  if (!io?.impersonazione) return null

  async function torna() {
    setInCorso(true)
    try {
      await api.post('/auth/impersonazione/fine')
      window.location.assign('/')
    } catch (e) {
      setInCorso(false)
      setErrore(e instanceof ErroreApi ? e.message : 'Non è andata a buon fine: controlla la connessione e riprova.')
    }
  }

  return (
    <div className="impersonazione-fascia" role="status">
      <span className="impersonazione-segno" aria-hidden="true" />
      <span className="impersonazione-testo">
        <strong>Stai vedendo il gestionale come {io.nome} {io.cognome}</strong>, in sola lettura: non si modifica
        niente e il messenger non si apre.
        {errore && <span className="impersonazione-errore"> {errore}</span>}
      </span>
      <span className="spinta">
        <Bottone variante="secondario" dimensione="piccolo" inCorso={inCorso} onClick={() => void torna()}>
          Torna al tuo profilo
        </Bottone>
      </span>
    </div>
  )
}

/** «Vedi come questo utente» (524): apre l'impersonazione e ricarica il gestionale da capo. */
export async function vediComeUtente(utenteId: string): Promise<void> {
  await api.post('/auth/impersonazione', { utenteId })
  window.location.assign('/')
}
